export const MAP_UPDATEGEOLOCATION = "MAP_UPDATEGEOLOCATION";

export const setLocation = (value) => ({
  type: MAP_UPDATEGEOLOCATION,
  payload: value,
});

export const setGeoLocation = (value) => {
  return setLocation(value);
};
